import React from "react";
import { ArrowRight, ArrowLeft } from "lucide-react";
import Video from "../assets/6937ddd2-8c5c-4791-ae25-872a1eacfe86.mp4";
import Img1 from "../assets/about-3.jpg";
import Img2 from "../assets/about-2.jpeg";
import about from "../assets/about-1.jpeg";
import dojo from "../assets/dojo.jpeg";

const TimelineItem = ({ year, title, description, image, alignRight }) => (
  <div className={`timeline-item ${alignRight ? "reverse" : ""}`}>
    <div className="timeline-img-wrapper">
      <img src={image} alt={title} className="grayscale-img" />
    </div>

    <div className="timeline-content">
      <h3 className="item-title">
        {year} — {title}
      </h3>
      <p className="item-description">{description}</p>
      <div className="btn-wrapper">
        <button className="circle-btn">
          {alignRight ? <ArrowRight size={16} /> : <ArrowLeft size={16} />}
        </button>
      </div>
    </div>
  </div>
);

export default function AboutPage() {
  return (
    <div className="about-container">
      <header className="hero">
        <h1 className="hero-text top">Successful</h1>
        <div className="hero-image-frame">
          <img src={about} />
        </div>
        <h1 className="hero-text bottom">History</h1>
        <div className="hero-subtext">
          <p>
            DOJO is a music mentorship platform created by Seth White to help
            producers and artists develop real skills, discipline, and
            professional direction in today’s music industry.
            {/* <strong>Swissfineline thrives on new challenges.</strong> */}
          </p>
        </div>
      </header>

      <main className="timeline-container">
        <div className="center-line"></div>
        <div className="timeline-header">
          <span>The Story Began</span>
          <div className="header-stub"></div>
        </div>

        <TimelineItem
          year="2025"
          title="A New Idea is Born"
          description="DOJO is a music mentorship platform created by Seth White to help producers and artists develop real skills, discipline, and professional direction in today’s music industry.

In a world full of random tutorials and scattered information, DOJO was built to provide something different — structured mentorship, direct guidance, and real industry insight.

At DOJO, creators don’t just watch videos. They train."
          image={Img1}
          alignRight={false}
        />

        <TimelineItem
          year="2025"
          title="The Concept Is Created"
          description="Members get access to live one-on-one mentorship sessions, producer demonstrations, structured learning programs, and feedback from experienced professionals who have spent years developing their craft. The goal is simple: help artists and producers finish better music, grow their sound, and move forward with clarity and confidence.

DOJO is inspired by the traditional idea of a dojo — a place where discipline, focus, and mastery are developed through practice and guidance from those who have already walked the path.

Whether you are a producer learning to build stronger records, an artist developing your sound, or a creator looking for real direction in the industry, DOJO is designed to help you level up both creatively and professionally.

DOJO is a platform by Seth White Productions LLC, built to support the next generation of serious music creators.

Train. Create. Grow."
          image={Img2}
          alignRight={true}
        />
      </main>

      <footer className="footer">
        <div className="footer-tagline">Journey Never Stops</div>
        <div
          className="footer-bottom"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "30px 15px",
            marginBottom: "0",
            textAlign: "center",
          }}
        >
          {/* Logo Image */}
          <img
            src={dojo}
            alt="DOJO Logo"
            style={{
              width: "100%",
              maxWidth: "240px",
              height: "auto",
              objectFit: "contain",
              marginBottom: "15px",
              filter: "drop-shadow(0px 6px 12px rgba(0,0,0,0.4))",
              transition: "transform 0.3s ease",
              cursor: "pointer",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />

          <h2
            style={{
              fontSize: "30px",
              fontWeight: "700",
              margin: "0",
              fontFamily: "'Playfair Display', serif",
              color: "#ffffff",
              letterSpacing: "1px",
              textShadow: "0px 3px 10px rgba(0,0,0,0.4)",
            }}
          >
            DOJO by SETH WHITE
          </h2>
          {/* Divider Line */}
          <div
            style={{
              width: "60px",
              height: "2px",
              background: "linear-gradient(90deg, #4CAF50, #2196F3)",
              margin: "10px 0",
              borderRadius: "5px",
            }}
          />
        </div>
      </footer>
    </div>
  );
}
